<template>
  <card class="card" title="Edit Profile">
    <div>
      <form @submit.prevent>
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Organization"
              :disabled="true"
              placeholder="Organization Name"
              v-model="user.company.data.name"
            >
            </fg-input>
          </div>
          <div class="col-md-6">
            <label for="allow_login" class="control-label">{{ $t('Allow login') }}</label>
            <multiselect
              v-model="allow_log_in"
              :options="allow_log_in_options"
              id="allow_login"
              track-by="value"
              label="name"
              :disabled="disableAllowLogin"
              :multiple="false"
              @select="updateAllowLogIn($event.value)"
              :close-on-select="true"
              :show-labels="false"
            >
            </multiselect>
          </div>
          <!--          <div class="col-md-4">-->
          <!--            <label for="language_select" class="control-label">{{$t('Language')}}</label>-->
          <!--            <multiselect v-model="chosen_language" :options="languages"-->
          <!--                         id="language_select"-->
          <!--                         track-by="language_code"-->
          <!--                         label="name"-->
          <!--                         :searchable="true"-->
          <!--                         :multiple="false"-->
          <!--                         @select="updateLanguage($event)"-->
          <!--                         :close-on-select="true"-->
          <!--                         :show-labels="false"-->
          <!--                         :placeholder="$t('choose_language')"> </multiselect>-->
          <!--          </div>-->
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text" label="First Name" placeholder="First Name" v-model="user.first_name"> </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Last Name" placeholder="Last Name" v-model="user.last_name"> </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="email" label="E-mail" placeholder="E-mail" v-model="user.email"> </fg-input>
          </div>
        </div>

        <div class="text-center">
          <p-button type="success" round @click.native.prevent="updateProfile"> Update Profile </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import Multiselect from 'vue-multiselect';
import axiosAuth from '../../../axiosMain';

export default {
  components: {
    Multiselect,
  },
  props: {
    user: {
      type: Object,
    },
    chosen_language: {
      type: Object,
    },
    disableAllowLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      languages: this.$store.getters.languages,
      allow_log_in_options: [
        {
          value: 1,
          name: 'Yes',
        },
        {
          value: 0,
          name: 'No',
        },
      ],
    };
  },
  computed: {
    allow_log_in() {
      return {
        value: this.user.allow_log_in,
        name: this.user.allow_log_in === 1 ? 'Yes' : 'No',
      };
    },
  },
  mounted() {
    this.canUpdateAllowLogin();
  },
  methods: {
    canUpdateAllowLogin() {
      if (!this.disableAllowLogin) {
        this.disableAllowLogin =
          (this.authUserHasScope('user_account_allowLogin_update_company') &&
            this.$store.getters.user.user_id != this.$route.params.id) ||
          (this.authUserHasScope('user_account_allowLogin_update_all') &&
            this.$store.getters.user.user_id != this.$route.params.id);
      }
    },
    authUserHasScope: function (scopeName) {
      let scopes = this.$store.getters.userScopes;
      return scopes.includes(scopeName);
    },
    updateProfile() {
      this.$emit('update', {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
      });
    },
    updateAllowLogIn: function (allowLogIn) {
      axiosAuth
        .patch(
          '/update_allow_log_in/' + this.$route.params.id,
          {
            allow_log_in: allowLogIn,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.user.allow_log_in = allowLogIn;
          this.$notify({
            type: 'success',
            title: 'Successful!',
            text: 'Allow login was updated',
          });
        });
    },
    updateLanguage: function (event) {
      axiosAuth
        .post(
          '/users/' + this.$route.params.id,
          {
            language: event.language_code,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          localStorage.setItem('language', event.language_code);
          this.user = response.data.data;
          this.$store.dispatch('fetchAuthUser');
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_language_was_updated'),
          });
          this.$router.go(this.$router.currentRoute);
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: 'Fehler: ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
  },
};
</script>

<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style></style>
